import axios from 'axios'

// A dedicated client for file downloads (e.g. CSV exports).
// It intentionally does NOT register the global response interceptors used by
// `amio.http-client.js` (which redirect to the 404 page / log out on error),
// so a failed export surfaces a normal rejected promise and the caller stays
// on the current page and can show an error toast.
const downloadHttpClient = axios.create({
  baseURL: process.env.VUE_APP_CHATBOT_ENGINE_URL
})

downloadHttpClient.interceptors.request.use(config => {
  config.headers['Authorization'] = `Bearer ${localStorage.access_token}`
  return config
})

export default downloadHttpClient
